import {useEffect} from 'react';


import Clarity from "@microsoft/clarity";
import {useAuth} from "@/provider/AuthProvider";
import {CLARITY_PROJECT_ID} from "@/constants/config";


export default function ClarityIdentify() {


    const {user} = useAuth()

    useEffect(() => {
        if (process.env.NODE_ENV && process.env.NODE_ENV === 'production') {

            Clarity.init(CLARITY_PROJECT_ID);

            if (!!user && user?.id) {
                Clarity.identify((user?.id).toString(), {})
            }
        }

    }, [user]);

    return null
}
